import 'focus-within-polyfill'
import eproc from './eproc'

require('./datatables')
window.plupload = require('plupload')
window.crudModal = require('./crudModal.js');
window.marked = require('marked');

(
    function($, eproc) {
        $(function() {
            eproc.init()
        })
    }
)(jQuery || $, eproc)